// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__sKjSl","modal-styles":"Layout_modal-styles__ycYlL"};